import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UserService } from '../../../auth/services/user.service';
import { ValidationResultsModule } from '../../../shared/components/validation-results/validation-results.module';
import { CustomerCoreModule } from '../../customer-core.module';
import { IndividualCustomerModule } from '../../detail/individual/individual-customer.module';
import { OrganizationCustomerModule } from '../../detail/organization/organization-customer.module';
import { CustomerManageService } from '../../shared/customer-manage.service';
import { IndividualCustomerDetailsModule } from '../individual/individual-customer-details.module';
import { CustomerDetailModalComponent } from './customer-details-modal.component';

@NgModule({
    declarations: [
        CustomerDetailModalComponent
    ],
    providers: [
        CustomerManageService,
        UserService
    ],
    imports: [
        CommonModule,
        RouterModule,
        CustomerCoreModule,
        IndividualCustomerModule,
        IndividualCustomerDetailsModule,
        OrganizationCustomerModule,
        ValidationResultsModule
    ],
    exports: [
        CustomerDetailModalComponent
    ]
})

export class CustomerDetailsModalModule {}
